/** The public website (landing page, Terms, Privacy Policy). Set VITE_SITE_URL for another domain. */
export const SITE_URL = (import.meta.env.VITE_SITE_URL || "https://superlivestream.com").replace(/\/+$/, "");
export const TERMS_URL = `${SITE_URL}/terms`;
export const PRIVACY_URL = `${SITE_URL}/privacy`;
